import { render, staticRenderFns } from "./edit-credit-modal.vue?vue&type=template&id=1bce6945"
import script from "./edit-credit-modal.vue?vue&type=script&lang=js"
export * from "./edit-credit-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports